import React from 'react';
import MapContainer from './components/MapContainer';
import './App.css';

function App() {
  return (
    <div className="App">
      <MapContainer />
    </div>
  );
}

export default App;